module.exports = __webpack_public_path__ + "img/入口2.bfe519a4.png";